import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FooterSocialLinks from "components/Footer/FooterSocialLinks";
import FooterDownloadApp from "components/Footer/FooterDownloadApp";
import FooterWebSummit from "components/Footer/FooterWebSummit";
import config from "config/config.js";

import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";

const whyFoodiestrip = {
  title: "why_foodiestrip.title",
  content: [
    {
      label: "why_foodiestrip.connect_to_customers",
      internalLink: {
        it: "/it/strumenti-marketing/",
        en: "/en/business/"
      },
      id: "connect_to_customers"
    },
    {
      label: "why_foodiestrip.our_vision",
      internalLink: {
        it: "/it/business/perche-foodiestrip/",
        en: "/en/business/why-foodiestrip/"
      },
      id: "our_vision"
    },
    {
      label: "why_foodiestrip.patented_checkin",
      internalLink: {
        it: "/it/business/perche-foodiestrip#patented-checkin",
        en: "/en/business/why-foodiestrip#patented-checkin"
      },
      id: "patented_checkin"
    },
    {
      label: "why_foodiestrip.categories_and_reviews",
      internalLink: {
        it: "/it/business/perche-foodiestrip#categories-and-reviews",
        en: "/en/business/why-foodiestrip#categories-and-reviews"
      },
      id: "categories_and_reviews"
    },
    {
      label: "why_foodiestrip.meet_your_customers",
      internalLink: {
        it: "/it/business/meet-your-customers",
        en: "/en/business/meet-your-customers"
      },
      id: "meet_your_customers"
    },
    {
      label: "why_foodiestrip.your_privacy_matters",
      internalLink: {
        it: "/it/business/meet-your-customers#your-privacy-matters",
        en: "/en/business/meet-your-customers#your-privacy-matters"
      },
      id: "your_privacy_matters"
    }
  ]
};

const certifyBusiness = {
  title: "certify_your_business.title",
  content: [
    {
      label: "certify_your_business.foodiestrip_for_business",
      internalLink: {
        it: "/it/business/foodiestrip-for-business",
        en: "/en/business/foodiestrip-for-business"
      },
      id: "foodiestrip_for_business"
    },
    {
      label: "certify_your_business.claim_your_business",
      internalLink: {
        it: "/it/business/foodiestrip-for-business#how-to-claim-your-business",
        en: "/en/business/foodiestrip-for-business#how-to-claim-your-business"
      },
      id: "claim_your_business"
    },
    {
      label: "certify_your_business.suggest_your_business",
      internalLink: {
        it: "/it/business/foodiestrip-for-business#suggest-your-business",
        en: "/en/business/foodiestrip-for-business#suggest-your-business"
      },
      id: "suggest_your_business"
    }
  ]
};

const businessPageGuide = {
  title: "business_page_guide.title",
  content: [
    {
      label: "business_page_guide.manage_page",
      internalLink: {
        it: "/it/business/manage-page",
        en: "/en/business/manage-page"
      },
      id: "manage_page"
    },
    {
      label: "business_page_guide.add_assistants",
      internalLink: {
        it: "/it/business/manage-page#add-assistants",
        en: "/en/business/manage-page#add-assistants"
      },
      id: "add_assistants"
    }
  ]
};
const marketingTools = {
  title: "marketing_tools.title",
  content: [
    {
      label: "marketing_tools.website",
      internalLink: {
        it: "/it/business/create-your-website",
        en: "/en/business/create-your-website"
      },
      id: "website"
    },
    {
      label: "marketing_tools.our_services",
      internalLink: {
        it: "/it/strumenti-marketing#our-services",
        en: "/en/business#our-services"
      },
      id: "our_services"
    },
    {
      label: "marketing_tools.experience",
      internalLink: {
        it: "/it/business/manage-your-photos/",
        en: "/en/business/manage-your-photos/"
      },
      id: "experience"
    },
    {
      label: "marketing_tools.social",
      internalLink: {
        it: "/it/strategie/social-network/",
        en: "/en/business/social-media-plan/"
      },
      id: "social_business"
    }
  ]
};

const foodiestripBox = {
  title: "foodiestrip.title",
  content: [
    {
      label: "foodiestrip.home_page",
      link: {
        it: "/it/",
        en: "/en/"
      },
      id: "home_page",
      blankTarget: true
    },
    {
      label: "foodiestrip.blog",
      link: {
        it: `${config.blogBaseUrl}/`,
        en: `${config.blogBaseUrl}/en/`
      },
      id: "blog",
      blankTarget: true
    },
    {
      label: "foodiestrip.mission",
      link: {
        it: "/it/mission/",
        en: "/en/mission/"
      },
      id: "companyData",
      blankTarget: true
    },
    {
      label: "foodiestrip.story",
      link: {
        it: "/it/story/",
        en: "/en/story/"
      },
      id: "companyData",
      blankTarget: true
    },
    {
      label: "foodiestrip.team",
      link: {
        it: "/it/team/",
        en: "/en/team/"
      },
      id: "companyData",
      blankTarget: true
    },
    {
      label: "foodiestrip.contact_us",
      link: {
        it: "/it/contact-us/",
        en: "/en/contact-us/"
      },
      id: "companyData",
      blankTarget: true
    },
    {
      label: "foodiestrip.talk_about_us",
      link: {
        it: `${config.blogBaseUrl}/foodiestrip-press/`,
        en: `${config.blogBaseUrl}/en/press-foodiestrip/`
      },
      id: "talk_about_us",
      blankTarget: true
    }
  ]
};

const areaOwner = {
  title: "area_owner.title",
  content: [
    {
      label: "area_owner.login",
      link: {
        it: `${config.backofficeBaseUrl}/it/}`,
        en: `${config.backofficeBaseUrl}/en/}`
      },
      id: "login"
    },
    {
      label: "area_owner.recover_password",
      internalLink: {
        it: "/it/recover-credentials",
        en: "/en/recover-credentials"
      },
      id: "recover_password"
    },
    {
      label: "area_owner.sign_up",
      internalLink: {
        it: "/it/business/sign-up/",
        en: "/en/business/sign-up/"
      },
      id: "sign_up"
    }
  ]
};

const aboutBox = {
  title: "about.title",
  content: [
    {
      label: "about.cookie_policy",
      link: {
        it: `${config.blogBaseUrl}/note-legali/cookie-policy/`,
        en: `${config.blogBaseUrl}/en/legal/cookie-policy/`
      },
      id: "cookiePolicy",
      blankTarget: true,
      rel: "nofollow"
    },
    {
      label: "about.terms_of_services",
      link: {
        it: `${config.blogBaseUrl}/note-legali/termini-e-condizioni/`,
        en: `${config.blogBaseUrl}/en/legal/terms-and-conditions/`
      },
      id: "termsAndConditions",
      blankTarget: true,
      rel: "nofollow"
    },
    {
      label: "about.privacy_policy",
      link: {
        it: `${config.blogBaseUrl}/note-legali/policy-privacy/`,
        en: `${config.blogBaseUrl}/en/legal/privacy-policy/`
      },
      id: "privacyPolicy",
      blankTarget: true,
      rel: "nofollow"
    },
    {
      label: "foodiestrip.toc",
      link: {
        it: `${
          config.blogBaseUrl
        }/note-legali/condizioni-generali-di-contratto/`,
        en: `${
          config.blogBaseUrl
        }/en/legal/terms-and-conditions-of-use-of-the-services/`
      },
      id: "tocPolicy",
      blankTarget: true,
      rel: "nofollow"
    },
    {
      label: "foodiestrip.company_data",
      link: {
        it: `${config.blogBaseUrl}/note-legali/`,
        en: `${config.blogBaseUrl}/en/legal/`
      },
      id: "companyData",
      blankTarget: true,
      rel: "nofollow"
    }
  ]
};

const buildRows = (rows, t, context) => {
  const buildLink = item => {
    if (item.link) {
      let title;
      if (
        typeof item.link === "object" &&
        item.link[context.props.defaultLanguage] &&
        item.link[context.props.defaultLanguage].includes("@")
      ) {
        const location = item.link[context.props.defaultLanguage].split("@");
        const locationNameArray = location[0].split("/");
        title = `${t("titleAndDescription.search_tag_title")} ${
          locationNameArray[1]
        } | foodiestrip.com`;
      } else {
        const name = item.label.split(".");
        title = t(`titleAndDescription.${name[1]}_tag_title`);
        title += " | foodiestrip.com";
      }
      // console.log('bulding link', item.link);
      return (
        <a
          target={item.blankTarget ? "_blank" : "_self"}
          href={
            item.link[context.props.defaultLanguage] ||
            `${config.baseUrl}/${context.props.defaultLanguage}/${item.link}`
          }
          className="footer_links_business"
          title={title}
          data-footerlinkid={item.id}
          rel={item.rel ? item.rel : null}
        >
          {t(`footer.${item.label}`)}
        </a>
      );
    }
    if (item.internalLink) {
      let title;
      const name = item.label.split(".");
      title = t(`titleAndDescription.${name[1]}_tag_title`);
      title += " | foodiestrip.com";
      return (
        <a
          target={"_self"}
          className="footer_links_business"
          href={`${item.internalLink[context.props.defaultLanguage]}`}
          title={title}
          data-footerlinkid={item.id}
          rel={item.rel ? item.rel : null}
        >
          {t(`footer.${item.label}`)}
        </a>
      );
    }
    return t(`footer.${item.label}`);
  };

  const buildContent = contentItems => (
    <ul>
      {contentItems.map(item => (
        <li key={item.label}>{buildLink(item)}</li>
      ))}
    </ul>
  );

  const buildBox = box => (
    <div key={box.title} className="footercontent_box">
      <div style={{ maxWidth: "220px", margin: "0 auto" }}>
        <div style={{ color: "#ffffff" }} className="titleFooterMenu">
          {box.isTitleHidden ? "\u200b" : t(`footer.${box.title}`)}
        </div>
        <div>{box.customContent || buildContent(box.content)}</div>
      </div>
    </div>
  );

  const buildEmptyBox = key => (
    <div key={key}>
      <div />
    </div>
  );

  const buildRow = (rowItems, key) => (
    <div className="footercontent_row_box" key={`row-${key}`}>
      {rowItems.map(
        (item, index) =>
          item.isEmpty ? buildEmptyBox(`box-${key}-${index}`) : buildBox(item)
      )}
    </div>
  );

  return rows.map((row, index) => buildRow(row, index));
};

export class Footer extends React.Component {
  static get NAME() {
    return "Footer";
  }

  constructor(props) {
    super(props);
    this.webSummitBox = {
      title: "Web Summit",
      isTitleHidden: true,
      customContent: (
        <div style={{ marginTop: "-32px" }}>
          <FooterWebSummit language={this.props.language} t={this.props.t} />
        </div>
      )
    };
    this.socialLinks = {
      // TODO cambiare
      title: "social.title",
      customContent: (
        <div>
          <FooterSocialLinks language={this.props.language} />
        </div>
      )
    };
    this.downloadAppBox = {
      // TODO cambiare
      title: "download.title",
      customContent: (
        <div>
          <FooterDownloadApp language={this.props.language} t={this.props.t} />
        </div>
      )
    };
    this.rows = [
      [whyFoodiestrip, certifyBusiness, marketingTools, this.webSummitBox]
    ];
    this.rowsLittle = [
      [whyFoodiestrip, certifyBusiness],
      [marketingTools, this.webSummitBox]
    ];
    this.secondRow = [
      [businessPageGuide, areaOwner, foodiestripBox, this.downloadAppBox],
      [this.socialLinks]
    ];
    this.secondRowLittle = [
      [businessPageGuide, areaOwner],
      [foodiestripBox, this.downloadAppBox],
      [this.socialLinks]
    ];
  }

  render() {
    const t = this.props.t;
    return (
      <footer>
        <div style={{ backgroundColor: "#002633" }}>
          <div className="footer-business-title">foodiestrip for business</div>
          <div className="footer-business-title" style={{ fontSize: "18px" }}>
            <div>{t("footer.footer_subtitle_1")}</div>
            <div>{t("footer.footer_subtitle_2")}</div>
          </div>
          <div className="business-footer-big">
            <div className="footercontent_row">
              {buildRows(this.rows, t, this)}
            </div>
            <div className="footercontent_row">
              {buildRows(this.secondRow, t, this)}
            </div>
          </div>
          <div className="business-footer-little">
            <div className="footercontent_row">
              {buildRows(this.rowsLittle, t, this)}
            </div>
            <div className="footercontent_row">
              {buildRows(this.secondRowLittle, t, this)}
            </div>
          </div>
          <div className="footercontent_row" style={{ color: "#ffffff" }}>
            <div
              className="footercontent_row_box"
              style={{ marginTop: "20px" }}
            >
              <div className="copyrights">
                <span>{t("footer.about.copy_rights1")}</span>
                <span>{moment().format("YYYY")}</span>
                <span>{t("footer.about.copy_rights2")}</span>
                {" / "}
                {aboutBox.content.map((el, index) => (
                  <span key={`footer-link-legals-${index.toString()}`}>
                    <a
                      href={el.link[this.props.language]}
                      target="blank"
                      title={t(`footer.${el.label}`)}
                      className="footer_links_business legal_footer_links"
                    >
                      {t(`footer.${el.label}`)}
                    </a>
                    {index !== aboutBox.content.length - 1 ? " / " : null}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool,
  t: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx